(function () {
  'use strict';

  function normalise(value) {
    return (value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/gi, ' ')
      .trim()
      .toLowerCase();
  }

  function headingNodes(root) {
    return Array.prototype.slice.call(root.querySelectorAll('h1, h2, h3, h4, h5, h6'));
  }

  function findHeading(root, matcher) {
    return headingNodes(root).find(function (heading) {
      return matcher(normalise(heading.textContent));
    });
  }

  function topLevelBlock(node, root) {
    var block = node;
    while (block.parentElement && block.parentElement !== root) block = block.parentElement;
    return block;
  }

  function containsHeading(node) {
    return node && (node.matches('h1, h2, h3, h4, h5, h6') || node.querySelector('h1, h2, h3, h4, h5, h6'));
  }

  function removeFollowingSectionContent(root, heading) {
    var start = topLevelBlock(heading, root);
    var current = start.nextElementSibling;
    while (current && !containsHeading(current)) {
      var next = current.nextElementSibling;
      current.remove();
      current = next;
    }
    return start;
  }

  function removeSection(root, heading) {
    if (!heading) return;
    var start = topLevelBlock(heading, root);
    var current = start;
    while (current) {
      var next = current.nextElementSibling;
      if (current !== start && containsHeading(current)) break;
      current.remove();
      current = next;
    }
  }

  function element(tag, html, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (html != null) node.innerHTML = html;
    return node;
  }

  function insertAfterSequence(marker, nodes) {
    nodes.forEach(function (node) {
      marker.insertAdjacentElement('afterend', node);
      marker = node;
    });
  }

  function list(items) {
    var ul = element('ul', null, 'mn-policy-list');
    items.forEach(function (item) {
      ul.appendChild(element('li', item));
    });
    return ul;
  }

  function updateShippingReturnsPage() {
    var root = document.querySelector('.mn-footer-page-content .text-rich-text');
    if (!root) return;

    var saleHeading = findHeading(root, function (text) {
      return text === 'sale items if applicable' || text.indexOf('sale items') === 0;
    });
    var restockingHeading = findHeading(root, function (text) {
      return text === 'restocking fee' || text.indexOf('restocking fee') === 0;
    });
    var stockistsHeading = findHeading(root, function (text) {
      return text.indexOf('manteau noir and victoria varrasso items purchased from our stockists') === 0;
    });
    var giftHeading = findHeading(root, function (text) {
      return text === 'gift card policy' || text === 'gift card terms' || text.indexOf('gift card policy') === 0;
    });

    /* These headings identify the Shipping & Returns page, avoiding unrelated pages. */
    if (!saleHeading && !restockingHeading && !stockistsHeading) return;

    removeSection(root, restockingHeading);
    removeSection(root, stockistsHeading);

    var oldSaleUpdate = root.querySelector('.mn-sale-items-updated');
    if (oldSaleUpdate) oldSaleUpdate.remove();
    var oldGiftUpdate = root.querySelector('.mn-gift-policy-updated');
    if (oldGiftUpdate) oldGiftUpdate.remove();

    if (saleHeading) {
      var saleBlock = removeFollowingSectionContent(root, saleHeading);
      var saleWrapper = element('div', null, 'mn-sale-items-updated');
      saleWrapper.appendChild(element('p', 'We can potentially offer you an exchange of size if the sale garment is available in stock. Please contact the Manteau Noir team on <a href="tel:+61353481902">+61 3 5348 1902</a> or email <a href="mailto:team@manteaunoir.com.au">team@manteaunoir.com.au</a> to determine if your required size is currently available. If we do not have an alternative size in stock, we are unable to offer you a return, exchange or refund.'));
      saleWrapper.appendChild(element('p', 'There are no change-of-mind returns or exchanges for sale items purchased online. Please carefully read the online product descriptions and, if unsure, contact our team on <a href="tel:+61353481902">+61 3 5348 1902</a> or email <a href="mailto:team@manteaunoir.com.au">team@manteaunoir.com.au</a>.'));
      saleWrapper.appendChild(element('p', '<em>*Refunds are only available on sale items if they are deemed faulty and adhere to our returns/refunds criteria noted above.</em>', 'mn-sale-items-note'));
      saleBlock.insertAdjacentElement('afterend', saleWrapper);
    }

    if (giftHeading) {
      var giftBlock = removeFollowingSectionContent(root, giftHeading);
      var giftWrapper = element('div', null, 'mn-gift-policy-updated');
      giftWrapper.appendChild(element('p', 'Manteau Noir gift cards are a considered way to give the pleasure of choice — for clothing, shoes, fragrance, beauty, objects and pieces for the home. Gift cards are issued in Australian dollars and may be used towards eligible purchases from Manteau Noir. A gift card may be used across more than one order until the full value has been spent. If the order value is greater than the balance of the gift card, the remaining amount must be paid using another accepted payment method. Gift cards are not redeemable for cash, except where required by law.'));
      giftWrapper.appendChild(element('p', 'Gift cards do not expire. Please keep the gift card code safe. Lost or stolen gift cards may not be able to be replaced unless proof of purchase and remaining balance can be verified.'));
      giftBlock.insertAdjacentElement('afterend', giftWrapper);
    }
  }

  function initialise() { updateShippingReturnsPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  window.addEventListener('pageshow', initialise);
})();
